<template>
    <div class="wrapper">

        <div class="image-container">
            <img :src="imageSrc" v-if="imageSrc"/>

            <!-- <v-icon class="no-image" v-if="!imageSrc && !loadingImage">mdi-radioactive</v-icon> -->
            <span class="no-image-text" v-if="!imageSrc && !loadingImage">No Image Available</span>

            <v-icon class="loading-image" v-if="!imageSrc && loadingImage">fas fa-spinner fa-spin</v-icon>
        </div>

        <div class="set-image-button-container">
            <v-btn class="mt-3" color="#C42111" @click="showSetImage = true" :disabled="$props.disabled">Set Site Image</v-btn>
        </div>

        <v-dialog v-model="showSetImage" max-width="80%" width="700px" persistent @keydown="(k) => {k.key == 'Escape' ? showSetImage = false : null}">
            <image-cropper v-if="showSetImage" :type="'site'" :title="`${$props.site.site_name} Site Image`" @cancel="showSetImage = false" @data="setImage"></image-cropper>
        </v-dialog>

    </div>
</template>

<script>
import ImageCropper from "@/components/ImageCropper";
export default {
    name: 'SiteImage',
    props: ['site', 'site_image', 'disabled'],
    components: {
        ImageCropper
    },
    data: () => ({
        imageSrc: '',
        showSetImage: false,
        loadingImage: false
    }),

    computed: {

    },

    methods: {
        setImage: function(data) {
            this.imageSrc = data;
            this.showSetImage = false;
            this.$props.site.image = data;
        },

        getImage: function() {
            this.loadingImage = true;
            let route = (`${TELSA.apiHost}site/image/${this.$props.site.site_id}`);
            this.$http.get(route).then(response => {
                let result = response.body;
                if(result) {
                    this.imageSrc = result;
                }
                this.loadingImage = false;
            });
        }
    },

    mounted() {
        if(this.$props.site.site_id != 0) {
            // Go to the server to get the site image data.
            this.getImage();
        }
        else {
            // This is a brand new site
            return
        }
    },
  
};
</script>

<style scoped>

    .wrapper {
        position: relative;
        max-width: 260px;
        margin-bottom: 10px;
    }

    .image-container {
        height: 260px;
        width: 260px;
        max-height: 260px;
        max-width: 260px;
        border: black solid 1px;
        position: relative;
    }

    .image-container img {
        max-height: 260px;
        max-width: 260px;
    }

    .image-container .no-image {
        width: 100%;
        height: 100%;
        font-size: 250px;
    }
    .image-container .no-image-text {
        width: 100%;
        height: 100%;
        font-size: 40px;
        text-align: center;
        display: block;
        margin-top: 55px;
    }

    .image-container .loading-image {
        width: 100%;
        height: 100%;
        font-size: 140px;
    }

    .set-image-button-container {
        text-align: center;
    }

    

</style>

